// extracted by mini-css-extract-plugin
module.exports = {"Cover":"style_Cover__rk_hp","Cover-background":"style_Cover-background__1LdIy","Cover-content":"style_Cover-content__3BGgl"};